// Google Tag Manager dataLayer helper.
// Pushes custom events that can be picked up as "Custom Event" triggers in GTM.
export const pushEvent = (event, data = {}) => {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...data });
};